<div class="container">
    <ng-container *ngIf="currentTileId">
        <div class="menu">
            <div kendoTooltip position="right">
                <smart-icon name="add-cycle" title="Add Tile" class="light" (click)="goBackAddTile()">
                </smart-icon>
            </div>
            <tam-wizard-menu [config]="wizardConfig"></tam-wizard-menu>
        </div>
        <div class="body">
            <div class="panel">
                <div class='panel-item' *ngIf="wizardConfig.config.active === 0">
                    <tam-tile-choose-visualization [config]="tileChooseConfig"></tam-tile-choose-visualization>
                </div>
                <div class='panel-item' *ngIf="wizardConfig.config.active === 1">
                    <!--other filter panel-->
                    <tam-tile-filter *ngIf="tileChooseConfig.config.type!==visualizationType.MAP"
                        [config]="tileFilterConfig"></tam-tile-filter>
                    <!-- map filter panel-->
                    <tam-tile-filter-nearby *ngIf="tileChooseConfig.config.type===visualizationType.MAP"
                        [config]="tileFilterConfig"></tam-tile-filter-nearby>
                </div>
                <div class='panel-item' *ngIf="wizardConfig.config.active === 2">
                    <tam-tile-column-setting [config]="tileConfig" [actionSubject$]="tileColumnsChange$"
                        #tileColumnSettingsComp>
                    </tam-tile-column-setting>
                </div>
                <div class='panel-item' *ngIf="wizardConfig.config.active === 3">
                    <tam-tile-chart-setting [tile]="tileConfig" #tileChartComp
                        *ngIf="tileChooseConfig.config.type!==visualizationType.NOTES&& tileChooseConfig.config.type!==visualizationType.GRID">
                    </tam-tile-chart-setting>
                    <tam-note-tile-chart-setting [config]="tileConfig" #tileChartComp
                        *ngIf="tileChooseConfig.config.type===visualizationType.NOTES">
                    </tam-note-tile-chart-setting>
                    <tam-tile-grid-setting #tileChartComp [config]="tileConfig.visualization.settings.gridSetting"
                        [action$]="updateGridSettings$" *ngIf="tileChooseConfig.config.type===visualizationType.GRID">
                    </tam-tile-grid-setting>
                </div>
                <div class='panel-item' *ngIf="wizardConfig.config.active === 4">
                    <tam-tile-settings [config]="tileSettings" #tileSettingsComp></tam-tile-settings>
                </div>
            </div>
            <div class="footer">
                <button *ngIf="showPreviousBtn" class="btn btn-primary" tam-button [tamType]="'tertiary'"
                    (click)="previous()">{{'dashboard.previous' | stringLiterals}}</button>
                <button *ngIf="showNextBtn" class="btn btn-primary" tam-button [tamType]="'primary'"
                    (click)="next()">{{'dashboard.next' | stringLiterals}}</button>
                <button *ngIf="showPreviewBtn()&&previewable" class="btn btn-primary" tam-button [tamType]="'primary'"
                    (click)="preview()">{{'dashboard.apply_preview' | stringLiterals}}</button>
                <button *ngIf="showPreviewBtn()&&!previewable" class="btn btn-primary" tam-button [tamType]="'primary'"
                    (click)="preview(true)">{{'dashboard.apply_settings' | stringLiterals}}</button>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="!currentTileId">
        <div class="data-visualizations">
            <span class="h3-regular">
                {{'dashboard.data_visualizations' | stringLiterals}}
            </span>
            <tam-data-visualizations [config]="addVisualizationsConfig">
            </tam-data-visualizations>
        </div>

    </ng-container>
</div>
<tam-formula-builder></tam-formula-builder>